export default {
  title: 'Kirjaudu sisään omalla osoitteellasi',
  description:
    'Tämä osoite kuuluu kumppanille, johon tilisi ei kuulu. Pidä tilisi turvassa kirjautumalla sisään normaalisti käyttämälläsi osoitteella — sähköpostisi ja salasanasi toimivat siellä.',
  continue: 'Jatka osoitteeseen {{host}}',
  password_changed: 'Salasanasi vaihdettiin.',
};
